export const muiListItem =  {
    styleOverrides: {
        root: {
            padding: 0
        }
    }
}